import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { EntityDataServiceAccessorService } from '@pit/core-data';
import { EntityStoreEffects } from '@pit/core-store';
import { IDtoDevice } from '@pit/frontend-model';
import { Observable } from 'rxjs';
import { DtoDeviceStoreFactory } from './dto.device.store.factory';

@Injectable()
export class DtoDeviceEffects extends EntityStoreEffects<IDtoDevice> {

    constructor(actions$: Actions, dataServiceAccessor: EntityDataServiceAccessorService) {
        super('dto.device', actions$, DtoDeviceStoreFactory.instance, dataServiceAccessor);
    }

    loadDevicesForMandatorByDepot$: Observable<Action> = DtoDeviceStoreFactory.instance.getEffect('get.by.depot')(this.actions$, this.dataServiceAccessor);

}
